module.exports = __webpack_public_path__ + "static/img/9.1e59923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/9.png
// module id = Pe7x
// module chunks = 0